import React from "react";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

type Props = {
    soldout: boolean,
};

const SoldOutFormatter = ({soldout}: Props) => {
    return (
        <Badge color={soldout ? "danger" : "success"}>
            <FormattedMessage
                id={soldout ? "soldOut" : "inStock"}
            />
        </Badge>
    );
};

export default SoldOutFormatter;